import { renderIconButton } from 'BomdisoftComponents/buttons/render';
import { attributes, type HtmlValue, html, joinClasses } from 'BomdisoftComponents/html/index';
import { CLOSE_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';
import { renderIcon } from 'BomdisoftComponents/icons/render';
import { renderTooltip } from 'BomdisoftComponents/tooltip/render';

export type SidePanelPlacement = 'bare' | 'docked' | 'flow';

export type SidePanelOptions = {
  actions?: HtmlValue;
  children?: HtmlValue;
  className?: string;
  closeLabel: string;
  closeTooltipId: string;
  dock?: HtmlValue;
  edge?: HtmlValue;
  footer?: HtmlValue;
  lead?: HtmlValue;
  meta?: HtmlValue;
  open?: boolean;
  placement?: SidePanelPlacement;
  testId?: string;
  title: HtmlValue;
  width?: number;
};

export const renderSidePanel = ({ actions, children, className, closeLabel, closeTooltipId, dock, edge, footer, lead, meta, open = false, placement = 'flow', testId, title, width }: SidePanelOptions) => {
  const sizing = width === undefined ? undefined : `--side-panel-width: ${width}px`;
  const close =
    placement === 'bare'
      ? ''
      : renderTooltip({
          children: renderIconButton({ attributes: { 'data-testid': testId === undefined ? undefined : `${testId}-close` }, children: renderIcon(CLOSE_ROUNDED_GLYPH, { size: 18 }), label: closeLabel, size: 'small' }),
          id: closeTooltipId,
          placement: 'left',
          title: closeLabel,
        });
  const secondary = meta === undefined ? '' : html`<span${attributes({ class: 'bomdisoft-side-panel-meta', 'data-testid': testId === undefined ? undefined : `${testId}-meta` })}>${meta}</span>`;
  const head = html`<div class="bomdisoft-side-panel-head">${lead}<span class="bomdisoft-side-panel-who"><span class="bomdisoft-side-panel-title">${title}</span>${secondary}</span><span class="bomdisoft-side-panel-spacer"></span>${actions === undefined ? '' : html`<span class="bomdisoft-side-panel-actions">${actions}</span>`}${close}</div>`;
  const docked = dock === undefined ? '' : html`<div${attributes({ class: 'bomdisoft-side-panel-dock', 'data-testid': testId === undefined ? undefined : `${testId}-dock` })}>${dock}</div>`;
  const foot = footer === undefined ? '' : html`<div${attributes({ class: 'bomdisoft-side-panel-footer', 'data-testid': testId === undefined ? undefined : `${testId}-footer` })}>${footer}</div>`;
  const card = html`<aside${attributes({ class: joinClasses('bomdisoft-side-panel', className), 'data-placement': placement, 'data-side-panel-sizer': placement === 'flow', 'data-testid': testId, style: placement === 'docked' ? undefined : sizing })}>${head}<div class="bomdisoft-side-panel-body">${children}</div>${docked}${foot}${edge}</aside>`;
  if (placement !== 'docked') return card;
  return html`<div${attributes({ class: 'bomdisoft-side-panel-holder', 'data-open': open, 'data-side-panel-sizer': true, style: sizing })}>${card}</div>`;
};
